var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.34,14.49l-1,-1.66c-0.21,-0.37 -0.4,-1.07 -0.4,-1.48l0,-2.53c0,-2.35 -1.38,-4.38 -3.37,-5.33c-0.52,-0.92 -1.48,-1.49 -2.58,-1.49c-1.09,0 -2.07,0.59 -2.59,1.52c-1.95,0.97 -3.3,2.98 -3.3,5.3l0,2.53c0,0.41 -0.19,1.11 -0.4,1.47l-1.01,1.67c-0.4,0.67 -0.49,1.41 -0.24,2.09c0.24,0.67 0.81,1.19 1.55,1.44c1.94,0.66 3.98,0.98 6.02,0.98c2.04,0 4.08,-0.32 6.02,-0.97c0.7,-0.23 1.24,-0.76 1.5,-1.45c0.26,-0.69 0.19,-1.45 -0.2,-2.09z",
    fill: "#9ca3af",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.83,20.01c-0.42,1.16 -1.53,1.99 -2.83,1.99c-0.79,0 -1.57,-0.32 -2.12,-0.89c-0.32,-0.3 -0.56,-0.7 -0.7,-1.11c0.13,0.02 0.26,0.03 0.4,0.05c0.23,0.03 0.47,0.06 0.71,0.08c0.57,0.05 1.15,0.08 1.73,0.08c0.57,0 1.14,-0.03 1.7,-0.08c0.21,-0.02 0.42,-0.03 0.62,-0.06c0.16,-0.02 0.32,-0.04 0.49,-0.06z",
    fill: "#9ca3af",
    id: "svg_2"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.33,
    cy: 4.35,
    fill: "#ffffff",
    id: "svg_4",
    rx: 4.6,
    ry: 4.18,
    stroke: "#000000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.18,
    cy: 4.3,
    fill: "#FF0000",
    id: "svg_3",
    rx: 3.12,
    ry: 2.97,
    stroke: "#000000",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIconOn);
export default __webpack_public_path__ + "static/media/notifIconOn.00263d21ae95e73a060f840cfeb0dcb8.svg";
export { ForwardRef as ReactComponent };